import { call, put, select } from 'redux-saga/effects';

import getUsers from './getUsers';

import { callAPI, METHODS } from '../../api';
import {
  setBannerAPIRequestState,
  userInviteError,
} from '../../../effects/message';
import { RESOURCES } from '../../../../helpers/constants';

export default function* inviteUser({ payload }) {
  const organizationId = yield select((state) => state.organization.uuid);

  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl}${RESOURCES.V3}/organizations/${organizationId}/users`;

  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.POST,
    body: {
      role: 'ADMIN',
      email: payload.email,
    },
  });

  if (success && !error) {
    yield put(
      setBannerAPIRequestState({
        bannerState: 'success',
        bannerMessage: `Invitation sent to ${payload.email}`,
      }),
    );
    yield call(getUsers);
  } else {
    console.error(error);
    yield put(userInviteError(payload.email));
    yield call(getUsers);
  }
}
